// Globals
import { MenuProps } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Store
import { useAppState } from '@/store';

// Components
import { getUsersRequestsTabsConfig, UsersRequestsTabs } from '../../helpers/configs';
import { StyledMenu, StyledPageWrapper } from '../../components/Styled';
import { StyledHeaderWrapper } from './UsersFeedbackContainerStyles';
import { selectNewFeedbacksCountByType } from '../../feature';

const UsersFeedbackContainer = () => {
  const { t } = useTranslation(['feedbacks']);
  const newCountByType = useAppState(selectNewFeedbacksCountByType);
  const tabsConfig = useMemo(() => getUsersRequestsTabsConfig(t, newCountByType), [t, newCountByType]);
  const [selectedKey, setSelectedKey] = useState(tabsConfig[0].key);

  const selectedTab = useMemo(() => tabsConfig.find((item) => item.key === selectedKey), [selectedKey, tabsConfig]);

  const onMenuButtonClick: MenuProps['onClick'] = (e) => {
    const newTab = e.key as UsersRequestsTabs;
    setSelectedKey(newTab);
  };

  return (
    <StyledPageWrapper>
      <StyledHeaderWrapper>
        <StyledMenu
          mode="horizontal"
          items={tabsConfig}
          defaultSelectedKeys={[selectedKey]}
          selectedKeys={[selectedKey]}
          onClick={onMenuButtonClick}
        />
      </StyledHeaderWrapper>

      {selectedTab?.content}
    </StyledPageWrapper>
  );
};

export default UsersFeedbackContainer;
